module.exports = __webpack_public_path__ + "img/icon_1227.33f8e7a2.svg";